module.exports = __webpack_public_path__ + "static/img/avatar.d874b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/avatar.png
// module id = lUu0
// module chunks = 15